
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import listado from './turnero-lista.vue';
    import jQuery from 'jquery';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;

        public get ControladorTurnero() { return this.Controlador.Turnero; }
        public get Turnero() { return this.Controlador.Turnero.Turnero; }

        public Modo: string = '';
        public SubModo: string = '';
        public Estado: string = '';
        public Cambiando: boolean = false;
        public EditaNumero: boolean = false;
        public ProximoNumero: number = null;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            if ( !this.ControladorTurnero.Iniciado )
                await this.ControladorTurnero.Iniciar();

            this.Estado = this.ControladorTurnero.Vista.Estado;
            this.Modo = this.ControladorTurnero.Vista.Modo;
            this.SubModo = this.ControladorTurnero.Vista.SubModo;
            this.Eventos.push( this.ControladorTurnero.onActualizar.subscribe( () => this.Refrescar() ) );
            this.Eventos.push( this.ControladorTurnero.Vista.onEstado.subscribe( () => this.Estado = this.ControladorTurnero.Vista.Estado ) );
            this.Eventos.push( this.ControladorTurnero.Vista.onModo.subscribe( () => this.Modo = this.ControladorTurnero.Vista.Modo ) );
            this.Eventos.push( this.ControladorTurnero.Vista.onSubModo.subscribe( () => this.SubModo = this.ControladorTurnero.Vista.SubModo ) );


        }

        public Refresh: boolean = true;
        Refrescar()
        {

            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        EditarNumero()
        {
            this.ProximoNumero = null;
            this.Cambiando = true;
            this.EditaNumero = true;
        }

        async GuardarNumero()
        {

            await this.ControladorTurnero.Reiniciar( this.ProximoNumero );
            await Wait( 100 );

            this.EditaNumero = false;
            this.Cambiando = false;
        }

        CancelarNumero()
        {
            this.Cambiando = false;
            this.EditaNumero = false;
        }

        async VolverALlamar()
        {
            this.Cambiando = true;
            await this.ControladorTurnero.Turnero.VolverALlamar();
            await Wait( 300 );
            this.$nextTick( () => this.Cambiando = false );
        }

        async Reiniciar()
        {
            this.Cambiando = true;
            await this.ControladorTurnero.Reiniciar();
            await Wait( 1000 );
            this.$nextTick( () => this.Cambiando = false );
        }

        async Siguiente()
        {
            this.Cambiando = true;
            await this.ControladorTurnero.Siguiente();
            await Wait( 1000 );
            this.$nextTick( () => this.Cambiando = false );
        }



        Cerrar()
        {
            this.Controlador.Vista.BarraDerecha.Modo = '';
        }
    }
